import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input, Checkbox, Select, Popconfirm } from 'antd';
import { isEmpty } from 'utils/utils';
import { QuestionCircleOutlined } from '@ant-design/icons';

export interface LectureGroupEditModalProps extends PopupProps {
    ginfo: LectureGroupListDto;
    clist?: LectureCategoryListDto[];
    onDelete: (gid:number) => void;
}

const LectureGroupEditModal = ({ isOpen, onClose, onDelete, ginfo, clist}: LectureGroupEditModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [isFormDone, setIsFormDone] = useState<boolean>(false);
    
  /* ======================================================
  * hooks
  * ====================================================== */


   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();

   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };

    const onSubmit = (e) => {
        onClose?.(
            true, 
            e.cid, 
            e.gname, 
            e.gname_eng,             
            e.price,             
            e.online_yn?'Y':'N', 
            e.use_yn?'Y':'N', 
            e.sale_yn?'Y':'N', 
            e.point_yn?'Y':'N', 
        );
    };

    const onChangeForm = () => { 
        setIsFormDone(
            !(isEmpty(form.getFieldValue('gname')))
        );        
    };      
       
  /* ======================================================
   * effects
   * ====================================================== */

    useEffect(() => {
        form.setFieldsValue({
            cid: ginfo.cid,
            gname: ginfo.gname,
            gname_eng: ginfo.gname_eng,
            price: ginfo.price,
            sale_yn: ginfo.sale_yn==='Y',
            online_yn: ginfo.online_yn==='Y',
            use_yn: ginfo.use_yn==='Y',
            point_yn: ginfo.point_yn==='Y',
        });
    }, []);

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={550} title={ginfo.gid===0?'과정 등록':'과정 수정'} closable>
            <Form
                form={form}
                name="CrmInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFieldsChange={onChangeForm}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item name="cid" label={'분류'}>
                    <Select placeholder="분류 선택">
                    {clist?.map((item) => {
                        return (<Select.Option key={item.cid} value={item.cid}>{item.cname}</Select.Option>)
                    })}                        
                    </Select>                    
                </Form.Item>  
                <Form.Item name="gname" label={'과정명'} rules={[{ required: true, message: '' }]}>
                    <Input type="text" placeholder='과정명을 입력하세요'/>                                        
                </Form.Item>  
                <Form.Item name="gname_eng" label={'영문 과정명'}>
                    <Input type="text" placeholder='영문 과정명을 입력하세요'/>                                        
                </Form.Item>  
                <Form.Item name="price" label={'교육비'} rules={[{ required: true, message: '' }]}>
                    <Input type="number" placeholder='교육비를 입력하세요'/>                    
                </Form.Item>  
                <Form.Item valuePropName="checked" name="online_yn" label={'장소구분'}>
                    <Checkbox>온라인</Checkbox>                   
                </Form.Item>   
                <Form.Item valuePropName="checked" name="sale_yn" label={'할인여부'}>
                    <Checkbox>할인</Checkbox>                   
                </Form.Item>  
                <Form.Item valuePropName="checked" name="use_yn" label={'사용여부'}>
                    <Checkbox>사용</Checkbox>                   
                </Form.Item> 
                <Form.Item valuePropName="checked" name="point_yn" label={'포인트적립'}>
                    <Checkbox>적립</Checkbox>                   
                </Form.Item> 
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCancel}>취소</Button>
                    <div>
                        <Popconfirm
                            title="삭제 하시겠습니까?"
                            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                            disabled={ginfo.gid === 0}
                            onConfirm={()=>{onDelete(ginfo.gid); onClose?.(false);}}
                        >
                            <Button disabled={ginfo.gid === 0}>Delete</Button>
                        </Popconfirm>
                        <Button style={{marginLeft:"10px"}} htmlType="submit"  type="primary" disabled={!isFormDone}>{ginfo.gid===0?'등록':'수정'}</Button>
                    </div>
                    
                </ButtonGroup>                
            </Form>
        </ModalWrapper>  
    )    
};

export default React.memo(LectureGroupEditModal);    